<template>
  <div class="home">
    <Login msg="Bienvenido al Sistema de Tareas" />
  </div>
</template>

<script>
// @ is an alias to /src
import Login from "@/components/Login.vue";

export default {
  name: "Home",
  components: {
    Login,
  },
};
</script>
